import type { AssetId, TimeStreamAssets } from 'owa-timestream-types';
import findAsset from './findAsset';
import refreshArray from '../refreshArray';

export default function updateAssetChildren(assets: TimeStreamAssets) {
    const childrenByParentId = new Map<AssetId, AssetId[]>();

    // Any asset with children needs to be visited, in case it ends up without children.
    for (const [id, { children }] of assets.entries()) {
        if (children.length > 0) {
            childrenByParentId.set(id, []);
        }
    }

    // Add non-deleted assets with parent to the corresponding children array
    for (const [id, { deleted, parentId }] of assets.entries()) {
        if (!deleted && parentId) {
            const children = childrenByParentId.get(parentId) || [];
            childrenByParentId.set(parentId, children);
            children.push(id);
        }
    }

    // The final list contains the IDs of assets that had or will now have children.
    // Apply these changes to the assets. Keep in mind an asset could point to
    // an invalid parent ID; if we don't find it, remove the link from the orphan.
    for (const [parentId, children] of childrenByParentId.entries()) {
        const parentAsset = findAsset(assets, parentId);
        if (parentAsset) {
            children.sort();
            refreshArray(parentAsset.children, children);
        } else {
            eraseParentId(assets, children);
        }
    }
}

function eraseParentId(assets: TimeStreamAssets, orphans: AssetId[]) {
    for (const assetId of orphans) {
        const asset = findAsset(assets, assetId)!;
        asset.parentId = null;
    }
}
